import api from './api.js'

// List endpoint returns PagedResponse<VehicleResponse> directly
export const getVehicles = (page = 0, size = 100) =>
  api.get('/v1/vehicles', { params: { page, size } }).then((r) => r.data?.content || [])

// Single vehicle endpoints return ApiResponseWrapper<VehicleResponse>
// Structure: { success, message, data: { vehicleUuid, plate, brand, ... } }
export const getVehicleById = (vehicleUuid) =>
  api.get(`/v1/vehicles/${vehicleUuid}`).then((r) => r.data?.data || r.data)

// Backend stores fuelType / transmissionType as Java enums (uppercase, e.g.
// PETROL, MANUAL). The DVLA / MOT enquiry endpoint returns them title case
// ('Petrol', 'Manual') because that's how DVLA encodes them. Normalise on
// the way out so create/update don't 400 on a case mismatch.
const ENUM_FIELDS = ['fuelType', 'transmissionType']
const normaliseEnumFields = (data) => {
  if (!data || typeof data !== 'object') return data
  const out = { ...data }
  for (const f of ENUM_FIELDS) {
    if (typeof out[f] === 'string') out[f] = out[f].toUpperCase()
  }
  return out
}

export const createVehicle = (data) =>
  api.post('/v1/vehicles', normaliseEnumFields(data)).then((r) => r.data?.data || r.data)

export const updateVehicle = (vehicleUuid, data) =>
  api.patch(`/v1/vehicles/${vehicleUuid}`, normaliseEnumFields(data)).then((r) => r.data?.data || r.data)

export const deleteVehicle = (vehicleUuid) =>
  api.delete(`/v1/vehicles/${vehicleUuid}`).then((r) => r.data)

export const searchByRegistration = (registration) =>
  api.get(`/v1/enquiry/plate/${registration}`).then((r) => r.data)

export const searchByVIN = (vin) =>
  api.get(`/v1/enquiry/vin/${vin}`).then((r) => r.data)
